import {
    Gem,
    Package,
    MonitorSmartphone,
    Share2,
    LayoutDashboard,
    TrendingUp,
} from "lucide-react";

// Image-first case studies. Visuals from ragimedia.com project work.
export const caseStudies = [
    {
        id: "brand-identity",
        title: "Brand Identity Transformation",
        category: "Branding",
        icon: Gem,
        image: "/cases/brand-identity.jpg",
        problem:
            "A capable business looked smaller than it really was. The identity was dated and inconsistent, so premium clients never took it seriously.",
        solution:
            "We rebuilt the identity from the ground up — logo, colours, type and tone — and gave the team one clear system to use everywhere.",
        metrics: [
            { value: "+85%", label: "Brand visibility" },
            { value: "Premium", label: "Market perception" },
            { value: "100%", label: "Consistent identity" },
        ],
    },
    {
        id: "packaging",
        title: "Packaging Design",
        category: "Packaging",
        icon: Package,
        image: "/cases/packaging.jpg",
        problem:
            "A good product kept getting ignored on the shelf. The packaging didn't show its quality, so shoppers walked past it.",
        solution:
            "We designed bold, shelf-ready packaging with a clear hierarchy and a premium finish that finally matches the product inside.",
        metrics: [
            { value: "+40%", label: "Shelf impact" },
            { value: "Higher", label: "Customer pickup" },
            { value: "Repeat", label: "Purchase lift" },
        ],
    },
    {
        id: "website-leads",
        title: "Website Redesign for Lead Generation",
        category: "Web Design",
        icon: MonitorSmartphone,
        image: "/cases/website.jpg",
        problem:
            "The old website looked tired and brought in almost no enquiries. People landed, got confused, and left.",
        solution:
            "We rebuilt it around one job: turn visitors into leads. Clear message, fast pages, and strong calls to action.",
        metrics: [
            { value: "+63%", label: "Qualified leads" },
            { value: "+72%", label: "Engagement" },
            { value: "Lower", label: "Bounce rate" },
        ],
    },
    {
        id: "social-growth",
        title: "Social Media Growth",
        category: "Digital Growth",
        icon: Share2,
        image: "/cases/social.jpg",
        problem:
            "Posting was random and the page felt dead. There was no plan, so the brand stayed invisible online.",
        solution:
            "We built a simple content system — themes, formats and a steady rhythm — so the brand shows up with purpose.",
        metrics: [
            { value: "2.4M+", label: "Total reach" },
            { value: "+68%", label: "Engagement" },
            { value: "Steady", label: "Growth" },
        ],
    },
    {
        id: "uiux-product",
        title: "UI UX Product Design",
        category: "Product Design",
        icon: LayoutDashboard,
        image: "/cases/uiux.jpg",
        problem:
            "A useful product was hard to use. Confusing screens frustrated people and pushed them to leave.",
        solution:
            "We simplified the flows and cleaned up the interface around how people actually behave, not how we assumed they would.",
        metrics: [
            { value: "93%", label: "User satisfaction" },
            { value: "Easier", label: "Task flow" },
            { value: "Lower", label: "Drop-off" },
        ],
    },
    {
        id: "visible-brand",
        title: "Business Growth & Brand Conversion",
        category: "Brand Growth",
        icon: TrendingUp,
        image: "/cases/visible-brand.jpg",
        problem:
            "A small business did good work but nobody noticed. It looked like a vendor, not a brand people trust and remember.",
        solution:
            "We turned the business into a visible brand — clear positioning, a strong look, and a presence that earns trust at first glance.",
        metrics: [
            { value: "Visible", label: "Recognised brand" },
            { value: "More", label: "Inbound enquiries" },
            { value: "Higher", label: "Customer trust" },
        ],
    },
];
